import styled, { css } from "styled-components";

export const ContentWrapper = styled.section<{ shouldAlignContent: boolean }>`
  display: flex;
  justify-content: center;
  height: 100%;
  ${({ shouldAlignContent }) =>
    shouldAlignContent &&
    css`
      align-items: center;
    `}
`;
